import * as React from 'react';
import BlueCargoLogo from 'components/BlueCargoLogo';
import { SignUpTemplate } from 'layouts/SignUpTemplate';
import { useIsLoggedIn } from 'ducks/user';
import { Navigate } from 'react-router-dom';
import { Routes } from 'constants/pages';
import { SignInForm } from './components/Form';
import styles from '../../styles/typography.module.css';

export const SignIn: React.FC = () => {
  const loggedIn = useIsLoggedIn();

  if (loggedIn) {
    return <Navigate to={Routes.Landing} />;
  }

  return (
    <SignUpTemplate className="p-0 flex justify-center" noLogo>
      <div
        className={`${styles.font} space-y-8 w-[500px] text-center flex flex-col items-center mt-8`}
      >
        <BlueCargoLogo variant="larger-blue" className="mb-8" destination="public-site" />
        <h1 className="font-bold">Sign in to BlueCargo</h1>
        <SignInForm />
      </div>
    </SignUpTemplate>
  );
};
SignIn.displayName = 'Pages.SignIn';
